import { getCountries } from 'libphonenumber-js';
import type { CountryCode } from 'libphonenumber-js';
import { useAppState } from 'lib/app-state';

const fallbackCountry: CountryCode = 'GB';

/** Region portion of a culture string (e.g. "is-IS" -> "IS"), when dialable. */
function toCountryCode(culture?: string | null): CountryCode | undefined {
  const region = culture?.split('-')[1]?.toUpperCase();
  if (!region) return undefined;
  return getCountries().includes(region as CountryCode)
    ? (region as CountryCode)
    : undefined;
}

/**
 * Region that seeds the country prefix on phone fields. The skin's own default
 * locale takes precedence over the chosen UI language, so an Icelandic skin
 * browsed in English still offers +354 rather than +44.
 */
export function useDefaultPhoneCountry(): CountryCode {
  const { appSettings, locale } = useAppState();
  return (
    toCountryCode(appSettings?.defaultLocale?.culture) ??
    toCountryCode(locale) ??
    fallbackCountry
  );
}
